import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { OrderReturn, OrderReturnCreate, OrderReturnFilter } from '../data/orderReturn';

export function createOrderReturnService(client: AxiosInstance) {
  return createCrudService<OrderReturn, OrderReturnCreate, OrderReturnFilter>(client, '/OrderReturn', 'orderReturnId');
}

export type OrderReturnService = CrudService<OrderReturn, OrderReturnCreate, OrderReturnFilter>;
